import ErrorManager from '@/common/utils/ErrorManager';
import PreventiveOutWidgetItems from '@/models/PreventiveOutWidgetItems';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import HomeService from '@/modules/Home/services/HomeService';
import { RootState } from '@/plugins/store';
import { ActionTree, Commit, MutationTree } from 'vuex';
import { PREVENTIVE_OUT_WIDGET } from '../mutation-types';
import { FiltreStats } from '@/models/FiltreStats';

export interface PreventiveOutState {
    preventiveOutItems: PreventiveOutWidgetItems;
    isLoading: boolean;
    error: boolean;
}

export enum PreventiveOutAction {
    GET_PREVENTIVE_OUT_DATA = 'GET_PREVENTIVE_OUT_DATA',
}
interface PreventiveOutActionType {
    commit: Commit;
    state: PreventiveOutState;
}

const initialState = (): PreventiveOutState => ({
    preventiveOutItems: {
        nbEnCours: 0,
        nbRealisees: 0,
        nbARealiser: 0,
        debutPeriode: '',
        finPeriode: '',
    },
    isLoading: false,
    error: false,
});

const actions: ActionTree<PreventiveOutState, RootState> = {
    async [PreventiveOutAction.GET_PREVENTIVE_OUT_DATA]({ commit, state }: PreventiveOutActionType, filtre: FiltreStats): Promise<void> {
        if(!state.isLoading){
            commit(PREVENTIVE_OUT_WIDGET.SET_LOADING, true);
            HomeService.getPreventiveOutData(filtre)
            .then(async response => {
                if (response !== undefined || response.status !== undefined) {
                    if (response.status !== 200) {
                        commit(PREVENTIVE_OUT_WIDGET.SET_ERROR, true);
                        commit(PREVENTIVE_OUT_WIDGET.SET_LOADING, false);
                        commit(
                            `errorToaster/${ERROR.SET_MESSAGE}`,
                            await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                            { root: true }
                        );
                    }
                    const preventiveOutItems: PreventiveOutWidgetItems = response.data;
                    commit(PREVENTIVE_OUT_WIDGET.SET_ITEMS, preventiveOutItems);
                    commit(PREVENTIVE_OUT_WIDGET.SET_LOADING, false);
                } else {
                    commit(PREVENTIVE_OUT_WIDGET.SET_ERROR, true);
                    commit(PREVENTIVE_OUT_WIDGET.SET_LOADING, false);
                    commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                        { root: true }
                    );
                }
            })
            .catch(async error => {
                commit(PREVENTIVE_OUT_WIDGET.SET_ERROR, true);
                commit(PREVENTIVE_OUT_WIDGET.SET_LOADING, false);
                commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
            });
        }
    },
};

const mutations: MutationTree<PreventiveOutState> = {
    [PREVENTIVE_OUT_WIDGET.SET_LOADING](state: PreventiveOutState, isLoading: boolean): void {
        state.isLoading = isLoading;
    },
    [PREVENTIVE_OUT_WIDGET.SET_ERROR](state: PreventiveOutState, error: boolean): void {
        state.error = error;
    },
    [PREVENTIVE_OUT_WIDGET.SET_ITEMS](state: PreventiveOutState, items: PreventiveOutWidgetItems): void {
        state.preventiveOutItems = items;
    },
    [PREVENTIVE_OUT_WIDGET.RESET](state: PreventiveOutState): void {
        Object.assign(state, initialState());
    },
};

const widgetTravaux = {
    namespaced: true,
    state: initialState,
    actions,
    mutations,
};

export default widgetTravaux;
